<style>
.gallery-item__screenshots {
  position: relative;
  height: 300px;
  margin-bottom: 20px;
  cursor: pointer;

  &:hover {
    > div {
      &:nth-child(1) {
        transform: rotate(0);
      }

      &:nth-child(2) {
        transform: rotate(3deg);
      }

      &:nth-child(3) {
        transform: rotate(-3deg);
      }
    }
  }

  > div {
    max-height: 300px;
    position: absolute;
    border: 2px solid #ddd;
    background: #fff;
    //clip: rect(0, 500px, 270px, 0);
    height: 300px;
    overflow: hidden;
    border-radius: 10px;
    transition: transform 200ms;

    &:nth-child(1) {
      transform: rotate(0);
    }

    &:nth-child(2) {
      transform: rotate(2deg);
    }

    &:nth-child(3) {
      transform: rotate(-2deg);
    }
  }

  img {
    width: 100%;
  }
}

.v-card.template-gallery__item.predefined {
  margin: 0 auto;
  .v-card__title, .v-icon {
    //color: #1876d2;
    font-weight: normal;
  }
  &:hover {
    background: #f7f7f7;
  }
}

#dialog-screenshots {
  height: calc(100% - 100px) !important;
  max-height: calc(100vh - 100px);
  @media (min-width: 1000px) {
    //max-width: 800px;
  }
  .v-window-item {
    overflow-y: scroll;
  }
  .v-window__container {
    height: calc(100% - 100px) !important;
    max-height: calc(100vh - 100px);
    @media (min-width: 1000px) {
      //max-width: 800px;
    }
  }
}

</style>

<template>
  <v-card
    :loading="loading"
    class="template-gallery__item predefined"
    :disabled="!$store.getters.userCanAddNewTemplates"
  >
    <div v-if="template.screenshots">
      <div class="gallery-item__screenshots" @click="dialog = true">
        <div v-for="(screenshot, i) in filteredScreenshots" :key="i">
          <img src="/img/google_sheets_head.png" style="width: calc(100% + 3px); margin: -2px 0 0 -1px"/>
          <img
            style="margin-top: -25px"
            :src="getScreenshotSrc(template.id, screenshot)"
          />
        </div>
      </div>

     <v-dialog
      v-model="dialog"
      max-width="1000"
    >
      <v-carousel
        id="dialog-screenshots"
        v-if="template.screenshots"
        :continuous="false"
        :cycle="cycle"
        :show-arrows="true"
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        height="none"
      >
        <v-carousel-item
          v-for="(screenshot, index) in template.screenshots"
          :key="index"
        >
          <v-sheet tile>
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <div class="text-h2" style="width: calc(100% - 60px); padding: 20px 0;">
                <img src="/img/google_sheets_head.png" style="width: 100%;" />
                <img
                  :src="screenshotSources[screenshot]"
                  style="width: 100%;"
                />
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-dialog>


      <div @click="useTemplate" style="cursor: pointer;">
        <v-card-title style="justify-content: space-between;">
          {{ template.name }}
          <v-btn x-small text color="#1876d2">
            <span style="font-size: 14px;">{{ translate('customize_btn') }}</span>
            <v-icon style="margin-left: 3px; font-size: 18px;">mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div>{{ template.copy && template.copy.pitch[0] }}</div>
        </v-card-text>
      </div>
    </div>

    <div
      v-if="!template.screenshots"
      @click="useTemplate"
      style="cursor: pointer; display: flex; flex-direction: column; text-align: center; align-items: center; padding: 20px 15px;"
    >
      <v-avatar size="65" tile>
        <i v-if="template && template.faIcon" :class=template.faIcon style="font-size: 26px; color: #1876d2;"></i>
        <v-icon large v-if="!template || !template.faIcon">mdi-table-large</v-icon>
      </v-avatar>
      <v-card-title
        style="justify-content: center; padding: 0; margin-top: 5px; font-size: 20px; width: calc(100% - 10px);"
      >
        <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
          {{ template ? template.name : addNewTemplate }}
        </div>
      </v-card-title>
    </div>

  </v-card>
</template>
<script>
import _ from 'lodash';
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplateGalleryPredefinedItem',
  props: {
    template: {},
  },
  mixins: [Mixin],
  data: () => ({
    dialog: false,
    cycle: false,
    loading: false,
    screenshotSources: {},
  }),
  methods: {
    async useTemplate() {
      const { template } = this;
      this.loading = true;
      const templateId = this.template.uuid || template.id;
      const { userId } = template;
      const templateObj = await this.$store.dispatch('getTemplateGalleryItem', {
        templateId,
        userId,
      });
      const newTemplate = JSON.parse(JSON.stringify(templateObj));
      // remove isLocked for users
      if (newTemplate.isLocked) {
        // eslint-disable-next-line
        newTemplate.isLocked = false;
      }
      const { language } = this.$store.state.user.settings;
      newTemplate.name = `${this.translate('new_template_name_prefix', language)} ${newTemplate.name}`;
      newTemplate.timestamp = Date.now();
      newTemplate.language = language;
      const newTemplateUUID = this.uuidv4();
      newTemplate.uuid = newTemplateUUID;
      await this.$store.dispatch('addTemplate', newTemplate);
      this.$router.push(`/template/${newTemplateUUID}`);
      this.loading = false;
    },
  },
  mounted() {
    if (this.template.screenshots) {
      this.template.screenshots.forEach((screenshot) => {
        const screenshotImgSrc = this.getScreenshotSrc(this.template.id, screenshot);
        this.screenshotSources[screenshot] = screenshotImgSrc;
        // preload screenshot
        const screenshotImg = new Image();
        screenshotImg.src = screenshotImgSrc;
      });
    }
  },
  computed: {
    filteredScreenshots() {
      // ordered as below
      const displayedSheets = ['-IS-', '-CF-', '-CHARTS-'];
      const mappedSheets = displayedSheets.map((ds) => this.template.screenshots.find((screenshot) => screenshot.includes(ds)));
      return _.shuffle(mappedSheets);
    },
  },
};
</script>
